import React, { useEffect, useRef, useState } from "react";
import avetar from "../../../assets/images/front/profile.webp";
import avetar2 from "../../../assets/images/front/logo.png";
import {
  ChevronUp,
  Image,
  MoreHorizontal,
  Paperclip,
  Smile,
} from "lucide-react";
import { Textarea } from "@headlessui/react";
import Dropdown from "../../form/Dropdown";
import Button from "../../form/front/Button";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  communicationChatList,
  CreateChat,
} from "../../../services/communicationService";
import { useSelector } from "react-redux";
import { useSocket } from "../../../providers/SocketContext";

const MessageContent = ({ activeChat }) => {
  const [message, setMessage] = useState("");
  const { session } = useSelector((state) => state.authProvider);

  const currentUserId = session?.user?._id;
  const queryClient = useQueryClient();
  const messagesEndRef = React.useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const { data, isLoading } = useQuery({
    queryKey: ["chat-messages", activeChat?._id],
    queryFn: async () => {
      const res = await communicationChatList({
        communicationGroupId: activeChat?._id,
      });
      return res?.docs?.data || [];
    },
    enabled: !!activeChat,
  });

  // ─── Real-time: receive messages from other users ───────────────────────────
  // ✅ AFTER — ref always reflects latest activeChat
  const activeChatRef = useRef(activeChat);
  useEffect(() => {
    activeChatRef.current = activeChat;
  }, [activeChat]);

  useSocket("receiveMessage", (res) => {
    const newMsg = res?.data?.data;
    if (!newMsg) return;

    const currentChat = activeChatRef.current; // always fresh

    if (newMsg.communicationGroupId !== currentChat?._id) return;
    if (newMsg.user === currentUserId) return;

    queryClient.setQueryData(["chat-messages", currentChat._id], (old = []) => {
      if (old.some((m) => m._id === newMsg._id)) return old;
      return [
        ...old,
        {
          _id: newMsg._id,
          content: newMsg.content,
          user: newMsg.user,
          createdAt: newMsg.createdAt,
          fullName:
            `${newMsg.userInfo?.firstName || ""} ${newMsg.userInfo?.lastName || ""}`.trim(),
          userInfo: newMsg.userInfo,
        },
      ];
    });
  });
  const sendMessageMutation = useMutation({
    mutationFn: (payload) => CreateChat(payload),

    onMutate: async (newMessage) => {
      await queryClient.cancelQueries(["chat-messages", activeChat?._id]);

      const previousMessages = queryClient.getQueryData([
        "chat-messages",
        activeChat?._id,
      ]);

      queryClient.setQueryData(
        ["chat-messages", activeChat?._id],
        (old = []) => [
          ...old,
          {
            _id: Date.now(),
            content: message,
            user: currentUserId,
            createdAt: new Date(),
            fullName: session?.user?.firstName,
          },
        ],
      );

      return { previousMessages };
    },

    onError: (err, newMessage, context) => {
      queryClient.setQueryData(
        ["chat-messages", activeChat?._id],
        context.previousMessages,
      );
    },

    // onSettled: () => {
    //   queryClient.invalidateQueries(["chat-messages", activeChat?._id]);
    // },
  });
  // const [sendType, setSendType] = useState("enter");
  const [isStarred, setIsStarred] = useState(false);

  const messages = data || [];
  useEffect(() => {
    if (messages.length > 0) {
      scrollToBottom();
    }
  }, [messages.length]);
  const messagedropdown = [
    {
      _id: 1,
      name: "Star",
      value: "enter",
      //   link: notificationLink,
    },
    {
      _id: 2,
      name: "Archieve",
      value: "click",
      //   link: "/manage-company",
    },
    {
      _id: 3,
      name: "Delete",
      value: "click",
      //   link: "/manage-company",
    },
  ];
  const getAvatarUrl = (msg) => {
    return msg?.userInfo?.image?.url || null;
  };

  const getDisplayName = (msg) => {
    return msg?.fullName || "Unknown";
  };
  const fileInputRef = React.useRef(null);
  const imageInputRef = React.useRef(null);

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleImageClick = () => {
    imageInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("File selected:", file);
  };
  const getOtherMember = () => {
    const members = activeChat?.memberData || [];

    if (!members.length) return null;

    return members.find((m) => m._id !== currentUserId) || members[0];
  };
  const groupMessagesByDate = (messages) => {
    const groups = {};

    messages.forEach((msg) => {
      const date = new Date(msg.createdAt).toDateString();

      if (!groups[date]) {
        groups[date] = [];
      }

      groups[date].push(msg);
    });

    return groups;
  };

  const groupedMessages = groupMessagesByDate(messages);
  const otherUser = getOtherMember();
  const handleSendMessage = () => {
    if (!message.trim()) return;

    const payload = {
      organization: activeChat?.organization || undefined, // optional
      customerId: currentUserId, // receiver
      createdBy: otherUser?._id,
      message: {
        user: otherUser?._id,
        content: message,
      },
    };

    sendMessageMutation.mutate(payload);
    setMessage("");
  };
  const handleKeyDown = (e) => {
    // Send on Enter (without Shift)
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  if (!activeChat) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        Select a conversation
      </div>
    );
  }
  return (
    <>
      <div className="w-full bg-white max-h-[calc(100vh-460px)] overflow-auto flex flex-col h-full">
        <div className="">
          {/* <div className="flex justify-between pl-2 pr-4 py-2 border-b-2 border-gray-200 sticky top-0 bg-white w-full"> */}
          {/* <div className="flex flex-col">
              <p className="font-semibold text-gray-900 text-sm">
                {otherUser
                  ? `${otherUser.firstName || ""} ${otherUser.lastName || ""}`
                  : "Unknown"}
              </p>
              <div className="flex gap-1 items-center">
                <div className="w-2 h-2 border-emerald-700 border-2 rounded-full"></div>
                <p className="text-xs text-gray-500">
                  <span className="">Mobile</span> • 1h ago
                </p>
              </div>
            </div> */}
          {/* <div className="flex gap-2 items-center">
              <Dropdown
                data={messagedropdown}
                xPlacement="bottomRight"
                dropdownContainer="w-72"
                buttonClasses="p-0 border-0 !text-sm text-gray-700"
                variantClass=""
                itemclasses="last:border-b-2"
                button={<i class="fa-solid fa-ellipsis"></i>}
                headerdropdownlabel="border-0 mt-0"
                headerlabel=" !text-sm"
                dropdownDownArrow="hidden"
              />
              <div>
                <Button
                  buttonIcon={
                    isStarred ? "fa-solid fa-star" : "fa-regular fa-star"
                  }
                  buttonClasses={`bg-transparent text-xl px-0 h-8 w-8 flex justify-center items-center hover:bg-gray-100 rounded-full ${
                    isStarred ? "text-yellow-400" : "text-gray-700"
                  }`}
                  buttonFunction={() => setIsStarred(!isStarred)}
                />
              </div> 
            </div>*/}
          {/* </div> */}

          <div className="flex flex-col px-3 py-2">
            {otherUser?.image?.url ? (
              <img
                src={otherUser.image.url}
                className="rounded-full w-14 h-14 object-cover"
              />
            ) : (
              <div className="w-14 h-14 rounded-full bg-palatte flex items-center justify-center text-white text-lg font-semibold">
                {otherUser?.firstName?.charAt(0)?.toUpperCase() || "U"}
              </div>
            )}

            <div className="mt-2 pl-2">
              <p className="text-gray-600 text-sm">
                <span className="font-semibold text-gray-800 text-base">
                  {otherUser
                    ? `${otherUser.firstName || ""} ${otherUser.lastName || ""}`
                    : "Unknown"}
                </span>
              </p>

              {/* Optional (if you later have bio/title) */}
              <p className="text-sm text-gray-500">{otherUser?.email || ""}</p>
            </div>
          </div>
          {/* <div className="flex gap-4 items-center">
            <div className="w-full border-b border-gray-200"></div>
            <div className="text-xs text-gray-500 whitespace-nowrap font-semibold">
              <span className="uppercase">Feb</span> 24
            </div>
            <div className="w-full border-b border-gray-200"></div>
          </div> */}
          <div className="p-4 space-y-4">
            {Object.keys(groupedMessages).map((date) => (
              <div key={date}>
                {/* Date Divider */}
                <div className="flex gap-4 items-center my-4">
                  <div className="w-full border-b border-gray-200"></div>
                  <div className="text-xs text-gray-500 whitespace-nowrap font-semibold">
                    {new Date(date).toLocaleDateString([], {
                      month: "short",
                      day: "numeric",
                    })}
                  </div>
                  <div className="w-full border-b border-gray-200"></div>
                </div>

                {/* Messages */}
                <div className="space-y-4">
                  {groupedMessages[date].map((msg) => {
                    const isMe = msg.user === currentUserId;

                    return (
                      <div
                        key={msg._id}
                        className={`flex gap-2 items-start w-full ${
                          isMe ? "justify-end" : ""
                        }`}
                      >
                        {!isMe &&
                          (getAvatarUrl(msg) ? (
                            <img
                              src={getAvatarUrl(msg)}
                              className="w-10 h-10 rounded-full"
                            />
                          ) : (
                            <div className="w-10 h-10 rounded-full bg-palatte flex items-center justify-center text-white text-sm font-semibold">
                              {getDisplayName(msg)?.charAt(0)?.toUpperCase()}
                            </div>
                          ))}

                        <div className="flex flex-col max-w-[70%]">
                          <div className="flex gap-2 items-center">
                            {!isMe && (
                              <h3 className="font-semibold text-gray-900 text-sm">
                                {msg.fullName}
                              </h3>
                            )}
                            <p className="text-gray-500 text-xs">
                              {new Date(msg.createdAt).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </p>
                          </div>

                          <div
                            className={`rounded-lg p-2 text-sm ${
                              isMe ? "bg-emerald-100 ml-auto" : "bg-gray-100"
                            }`}
                          >
                            {msg.content}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
        </div>
      </div>

      <div className="w-full border-t">
        <div className="p-3">
          <div className=" rounded-md">
            <Textarea
              rows={3}
              placeholder="Write a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full bg-transparent resize-none outline-none text-sm text-gray-800 placeholder-gray-500 rounded-md border-0 !bg-gray-200"
            />
          </div>
        </div>

        <div className="flex items-center justify-between px-3 pb-3">
          {/* <div className="flex items-center gap-1 text-gray-500">
            <Button
              buttonIcon="fa-regular fa-image"
              buttonClasses="!bg-transparent !text-gray-500 hover:!bg-gray-100 !h-8 !w-8 !p-0 text-xl"
              buttonFunction={handleImageClick}
            />

            <Button
              buttonIcon="fa-solid fa-paperclip"
              buttonClasses="!bg-transparent !text-gray-500 hover:!bg-gray-100 !h-8 !w-8 !p-0 text-xl"
              buttonFunction={handleFileClick}
            />

            <Button
              buttonLabel="GIF"
              buttonClasses="!bg-transparent !text-gray-600 hover:!bg-gray-100 !h-8 px-2 text-xl"
              buttonLabelClasses={"font-semibold"}
            />

            <Button
              buttonIcon="fa-regular fa-face-smile"
              buttonClasses="!bg-transparent !text-gray-500 hover:!bg-gray-100 !h-8 !w-8 !p-0 text-xl"
            />

            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              onChange={handleFileChange}
            />

            <input
              type="file"
              accept="image/*"
              ref={imageInputRef}
              className="hidden"
              onChange={handleFileChange}
            />
          </div> */}

          <div className="flex items-center gap-4 text-sm text-gray-500">
            {/* <span className="hidden sm:block">Press Enter to send</span> */}
            <Button
              buttonLabel={"Send"}
              buttonClasses={"rounded-full h-8 px-4"}
              buttonFunction={handleSendMessage}
              disabled={!message.trim()}
            />
            {/* <Dropdown
              data={sendmode}
              onChange={(item) => setSendType(item.value)}
              xPlacement="bottomRight"
              dropdownContainer="w-72"
              buttonClasses="p-0 border-0 !text-base text-gray-600"
              variantClass="mt-4"
              itemclasses="last:border-b-2"
              button={<i class="fa-solid fa-ellipsis"></i>}
              headerdropdownlabel="border-0 mt-0"
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageContent;
